module.exports = "<a class=\"kl-menu-item {class}\" r-class={ {'is-active': active} } on-click={this.goto($event)} r-route={url+route} target={target}>\n  {#if title}\n    {title}\n  {#else}\n    {#inc this.$body}\n  {/if}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLMenu/KLMenuItem/index.html
// module id = 501
// module chunks = 0